// extracted by mini-css-extract-plugin
module.exports = {"Cancel":"Cancel__3FxK_"};